import { useContext, useMemo } from "react";
import { ModalSettingContext } from "../../index";
import s from './index.module.css';
import { useGetGroup } from "@/hooks/useGetGroup";
import Select from "@UI/New/Select";
import { compareOptionsByLabel } from "@/helpers/new/compareOptionsByLabel";
import useRoles from "@/hooks/useRoles";
import { filterOptionsByLabel } from "@/helpers/new/filterOptionsByLabel";

export const Groups = () => {
    const { state, setFieldInState } = useContext(ModalSettingContext);
    const { isSeminarian, isSeniorSeminarian } = useRoles();

    const filter = useMemo(
        () => {
          const filters = [
            `[direction_id][eq]=${state.direction}`,
          ]
          return filters;
        },
        [state.direction]
    );

    const groups = useGetGroup(
        (isSeminarian || isSeniorSeminarian),
        { filter },
        ({ direction_id }) => direction_id === state.direction,
        state.direction ? true : false,
        false,
        true
    );

      const fieldsSeminarian = {
        tokenSeparators: [','],
        mode: "multiple",
        showSearch: true,
        allowClear: true,
        filterSort: compareOptionsByLabel,
        filterOption: filterOptionsByLabel,
        onChange: e => setFieldInState({field: 'groups', value: e, resetFields: ['unavailableStudents'] }),
        options: !state.direction ? [] : groups.select,
        value: state.groups,
        placeholder: 'Выберите группы / потоки',
        notFoundContent: !state.direction ? 'Сначала выберите курс' : 'Группы не найдены'
    };

    return (
        <Select 
            fields={fieldsSeminarian} 
            wrapperClassName={s.wrapperSelect} 
            className={s.select} 
        />
    );
}